export const GIFT_UNIT_PRICE_USD = 349;

export const GIFT_MAX_PLAN_QUANTITY = 10;

export const MEMBERSHIP_ANNUAL_PRICE_USD = 349;
